import { Dayjs } from 'dayjs';
import { BaseTheme } from 'design-system';
import { ProductData } from 'generated/graphql';

export const enum ProductScreens {
  PRICING = 0,
  SUPPLY = 1,
  MARKET_PREVIEW = 2,
}

export const DAYS_MOBILE = 2;
export const DAYS_DESKTOP = 7;
export const REQUEST_DAYS = 21; //multiple of DAYS_DESKTOP
export const REQUEST_DAYS_MOBILE = 16; //multiple of DAYS_MOBILE

export const DEFAULT_LOCATION_ID = '0';
export const DEFAULT_PAGE_SIZE = 25;
export const XL_PAGE_SIZE = 100;

export type ProductScreenType = 'Pricing' | 'Supply' | 'MarketPreview';

export interface MarketRow {
  label: string;
  cells: {
    value: string;
    highlighted: boolean;
  }[];
}

export const getProductsPriceAvg = (productType: ProductData[]) => {
  let total = 0;
  let count = 0;
  productType.forEach((product) => {
    product.prices.forEach((price) => {
      if (price.amount && price.amount > 0) {
        total += price.amount;
        count++;
      }
    });
  });
  return count > 0 ? total / count : undefined;
};

export const paperStyle = (theme: BaseTheme) => ({
  margin: theme.spacing(1, 0, 2),
  padding: theme.spacing(2),
  background: theme.palette.common.white,
  [theme.breakpoints.down('md')]: {
    all: 'unset',
  },
});

export const getDayOfWeek = (date: Dayjs) => {
  const days = [6, 0, 1, 2, 3, 4, 5];
  return days[date.day()];
};
